module.exports = __webpack_public_path__ + "media/newstyle/images/book-3-8a6d4636453e7662ce2d5d7cad21201f.png";